import { render, staticRenderFns } from "./ListagemCompraDiretaLegada.vue?vue&type=template&id=247fe9ce&scoped=true"
import script from "./ListagemCompraDiretaLegada.vue?vue&type=script&lang=js"
export * from "./ListagemCompraDiretaLegada.vue?vue&type=script&lang=js"
import style0 from "./ListagemCompraDiretaLegada.vue?vue&type=style&index=0&id=247fe9ce&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fe9ce",
  null
  
)

export default component.exports